import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import PrivateSpaceDetailsStore from "../../stores/PrivateSpaceDetailsStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import GoogleAPILibStore from "../../stores/GoogleAPILibStore";
import SpaceDetailsView from "../views/SpaceDetailsView";
import PrivateMyAdvertisementsStore from "../../stores/PrivateMyAdvertisementsStore";
import SavingStates from "../../constants/states/SavingStates";
import LoadingView from "../views/LoadingView";
import ProfileStore from "../../stores/ProfileStore";
import SpaceDetailsPreviewView from "../views/SpaceDetailsPreviewView";


export default class SpaceDetailsContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "googleAPILibState": GoogleAPILibStore.getState(),
            "privateSpaceDetailsStore": PrivateSpaceDetailsStore.getState(),
            "privateMyAdvertisementsStore": PrivateMyAdvertisementsStore.getState(),
            "profileState": ProfileStore.getState()
        }
    }

    componentDidMount() {
        this.googleAPILibStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.GOOGLE_API_LIB_STORE_UPDATED, this.handleStoreUpdate);
        this.privateSpaceDetailsStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PRIVATE_SPACE_DETAILS_STORE_UPDATE, this.handleStoreUpdate);
        this.privateMyAdvertisementsStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PRIVATE_MY_ADVERTISEMENTS_STORE_UPDATE, this.handleStoreUpdate);
        this.profileStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PROFILE_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GOOGLE_API_LIB_REQUIRED, {});
        EventPublisher.publish(UIInteractionEvents.PRIVATE_SPACE_DETAILS_SET_SPACE_ID, {"id" :this.props.match.params.id})
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.privateSpaceDetailsStoreSubscriber);
        EventPublisher.unsubscribe(this.googleAPILibStoreSubscriber);
        EventPublisher.unsubscribe(this.privateMyAdvertisementsStoreSubscriber);
        EventPublisher.unsubscribe(this.profileStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.PRIVATE_SPACE_DETAILS_UNMOUNTED, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "googleAPILibState": GoogleAPILibStore.getState(),
            "privateSpaceDetailsStore": PrivateSpaceDetailsStore.getState(),
            "privateMyAdvertisementsStore": PrivateMyAdvertisementsStore.getState(),
            "profileState": ProfileStore.getState()
        });
    };

    render() {
        if (this.state.googleAPILibState.loadingState !== LoadingStates.FINISHED_LOADING ||
            this.state.privateSpaceDetailsStore.loadingState === LoadingStates.INITIALIZED ||
            this.state.privateSpaceDetailsStore.loadingState === LoadingStates.LOADING ||
            this.state.privateSpaceDetailsStore.calendarLoadingState !== LoadingStates.FINISHED_LOADING ||
            this.state.privateMyAdvertisementsStore.myAdvertisementsLoadingState !== LoadingStates.FINISHED_LOADING
        ) {
            return (
                <LoadingView titleText="Loading Space"/>
            );
        }

        if (this.state.privateSpaceDetailsStore.loadingState === LoadingStates.FAILED_TO_LOAD) {
            return (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="alert alert-danger" role="alert">
                                    Sorry we were unable to find the space you are looking for. Please try another one.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }


        if (this.state.privateSpaceDetailsStore.space.memberId !== this.state.profileState.memberId) {
            return this._renderOtherPersonsSpaceDetails();
        }
        return this._renderMySpaceDetails();
    }

    _renderMySpaceDetails() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div>
                                <SpaceDetailsPreviewView
                                    spaceId={this.state.privateSpaceDetailsStore.space.spaceId}
                                    title={this.state.privateSpaceDetailsStore.space.title}
                                    description={this.state.privateSpaceDetailsStore.space.description}
                                    pricePerDay={this.state.privateSpaceDetailsStore.space.pricePerDay}
                                    minimumDays={this.state.privateSpaceDetailsStore.space.minimumDays}
                                    distance={this.state.privateSpaceDetailsStore.space.distance}
                                    created={this.state.privateSpaceDetailsStore.space.created}
                                    latitude={this.state.privateSpaceDetailsStore.space.latitude}
                                    longitude={this.state.privateSpaceDetailsStore.space.longitude}
                                    imageNames={this.state.privateSpaceDetailsStore.space.imageNames}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _renderOtherPersonsSpaceDetails() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div>
                                <SpaceDetailsView
                                    isSaving={this.state.privateSpaceDetailsStore.savingState === SavingStates.SAVING}
                                    spaceId={this.state.privateSpaceDetailsStore.space.spaceId}
                                    title={this.state.privateSpaceDetailsStore.space.title}
                                    description={this.state.privateSpaceDetailsStore.space.description}
                                    pricePerDay={this.state.privateSpaceDetailsStore.space.pricePerDay}
                                    minimumDays={this.state.privateSpaceDetailsStore.space.minimumDays}
                                    distance={this.state.privateSpaceDetailsStore.space.distance}
                                    created={this.state.privateSpaceDetailsStore.space.created}
                                    latitude={this.state.privateSpaceDetailsStore.space.latitude}
                                    longitude={this.state.privateSpaceDetailsStore.space.longitude}
                                    imageNames={this.state.privateSpaceDetailsStore.space.imageNames}
                                    status={this.state.privateSpaceDetailsStore.space.status}
                                    unavailableDates={this.state.privateSpaceDetailsStore.unavailableDates}
                                    myOpenAdvertisements={this.state.privateMyAdvertisementsStore.openAdvertisements}
                                    currentSelectedAdvertisement={this.state.privateSpaceDetailsStore.currentSelectedAdvertisement}
                                    currentSelectedReservationRange={this.state.privateSpaceDetailsStore.currentSelectedReservationRange}
                                    showSelectedRangeIsTooShortAlert={this.state.privateSpaceDetailsStore.showSelectedRangeIsTooShortAlert}
                                    showSelectedRangeOverlapsUnavailableRangeAlert={this.state.privateSpaceDetailsStore.showSelectedRangeOverlapsUnavailableRangeAlert}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


}